import { Component } from "@angular/core";

@Component({
  selector: "adaa-transformational-agreements-screen",
  imports: [],
  templateUrl: "./transformational-agreements-screen.html",
  styleUrl: "./transformational-agreements-screen.scss",
})
export class TransformationalAgreementsScreenComponent {}
